export default __webpack_public_path__ + "media/images/upsell_bg-44c29868681e34bde0a0aca3986a51a3.jpg";